import CityPage from "../CityPage";

export default function Romeoville() {
  return <CityPage slug="romeoville" />;
}
